/* istanbul ignore file */

import { MessageIdentifier } from "@plex/culture-core";

import { mainApi } from "config";
import { getClientFor } from "infrastructure/http";

import { IMessageTranslation } from "./MessageTranslations.state";

export const getMessageTranslations = async (messageId: MessageIdentifier) =>
  (await getClientFor(mainApi.name).get<IMessageTranslation[]>(`/messages/${messageId}/translations`)).data;
